import  React , {useEffect, useState} from 'react';
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
} from "recharts";
import { SERIES, INK, axisProps, gridProps, ChartTooltip } from "../chartTheme";
import useMediaQuery from '@mui/material/useMediaQuery'; 
import { Box } from '@mui/material';
import axios from 'axios';
import API_BASE_URL from '../../components/config/appConfig';
import moment from 'moment';
import { useSelector, useDispatch } from "react-redux";

export default function SprintAnalysis() {

  const [data, setdata]=useState([])
  const  [shouldRotateLabels,setShouldRotateLables]=useState(false)
  const { Skeleton,Projects } = useSelector((state) => state.ProjamAppSlice)
  let backlogId = Projects?.selectedProject?.selectedProjectBackLogId
  let projectId = Projects?.selectedProject?.selectedProjectData?._id
  let LastFiveActiveSprint = Projects?.selectedProject?.lastFiveSprintsInfo || []
   
  const isMobile = useMediaQuery('(max-width:600px)');

  useEffect(()=>{
    if(projectId && backlogId && LastFiveActiveSprint.length>0){
      getLastFiveActiveSprints()
    }
  },[projectId,backlogId ,LastFiveActiveSprint])

const getLastFiveActiveSprints=async ()=>{
  try{
   //let response = await axios(`${API_BASE_URL}/sprints/lastFiveActive?backlogId=${backlogId}&projectId=${projectId}`)
    let response = [...LastFiveActiveSprint]
    //console.log(LastFiveActiveSprint , 'last five sprint')
    getSprintAnalysisData(response?.reverse())
  }catch(error){
    console.log(error)
  }
}

  
  const getDuration = async(sprintInfo)=>{
  let startDate=moment(sprintInfo?.startDate);
  let endDate=moment(sprintInfo?.endDate);
  return endDate.diff(startDate, "days")/7;
  }
  
  const getSprintAnalysisData=async(data)=>{
  let barGraphData = await Promise.all(data.map(async(each)=>{
      let weeks= await getDuration(each)
      let sprintName= each?.name
      return {sprintName:sprintName , weeks:weeks}
  }))
  setdata(barGraphData)
   setShouldRotateLables(data.some((item) => item?.name?.length > 15))
  }

  return (
    <Box sx={{ width: "100%", overflowX: "auto" }}>
      <Box sx={{ minWidth: 340 }}> 
    <ResponsiveContainer width="100%"
    height={385}>
    <BarChart
      data={data}
      margin={{
        top: 5,
        right: 30,
        left: 20,
        bottom: 5,
      }}
    >
      <CartesianGrid {...gridProps} />

      <XAxis
        dataKey="sprintName"
        {...axisProps}
        angle={isMobile ? -30 : 0}
        textAnchor={isMobile ? "end" : "middle"}
        interval={0}
        height={isMobile ? 70 : 30}
        tick={{ fill: INK.muted, fontSize: isMobile ? 10 : 12 }}
      />

      <YAxis
        {...axisProps}
        axisLine={false}
        tickFormatter={(value) => `${value}w`}
        allowDecimals={false}
        width={44}
      />
      <Tooltip
        content={<ChartTooltip valueSuffix=" weeks" />}
        cursor={{ fill: "rgba(42,120,214,0.06)", radius: 8 }}
      />
      <Bar
        dataKey="weeks"
        name="Duration"
        fill={SERIES[0]}
        radius={[4, 4, 0, 0]}
        maxBarSize={38}
      />
    </BarChart>
    </ResponsiveContainer>
    </Box>
    </Box>
  );
}
